import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';

import { appShell } from '@savgroup-front-common/core/helpers';
import { generateUserManager } from '@savgroup-front-common/core/services/userManager';

import '../datadog.config';

import AuthConfig from './configuration/auth/Auth.config';
import './index.css';
import App from './view/app/App';

const userManager = generateUserManager(AuthConfig);

appShell({
  userManager,
  render: () => {
    const container = document.getElementById('root');

    if (!container) {
      throw new Error('Container not found. Please check your HTML code.');
    }

    const root = createRoot(container);

    root.render(
      <AuthProvider userManager={userManager} skipSigninCallback>
        <App />
      </AuthProvider>,
    );
  },
});
